import { useEffect, useState } from 'react';
import {
  filterHomepageWebinars,
  type HomeWebinar,
} from '@/components/webinars/PublicHomeWebinarsSection';
import { webinarApi } from '@/lib/webinar-api';

let cachedWebinars: HomeWebinar[] | null = null;
let loadPromise: Promise<HomeWebinar[]> | null = null;

export async function loadPublicHomeWebinars(): Promise<HomeWebinar[]> {
  if (cachedWebinars) return cachedWebinars;
  if (!loadPromise) {
    loadPromise = webinarApi
      .homepagePublicWebinars()
      .then((data) => {
        const raw = Array.isArray(data.webinars) ? data.webinars : [];
        cachedWebinars = filterHomepageWebinars(raw);
        return cachedWebinars;
      })
      .catch(() => {
        cachedWebinars = [];
        return cachedWebinars;
      });
  }
  return loadPromise;
}

export function usePublicHomeWebinars() {
  const [webinars, setWebinars] = useState<HomeWebinar[]>(cachedWebinars ?? []);
  const [loaded, setLoaded] = useState(cachedWebinars !== null);

  useEffect(() => {
    let cancelled = false;
    void loadPublicHomeWebinars().then((items) => {
      if (!cancelled) {
        setWebinars(items);
        setLoaded(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { webinars, loaded, hasWebinars: webinars.length > 0 };
}

export function usePublicWebinarsNavVisible() {
  const { hasWebinars, loaded } = usePublicHomeWebinars();
  return loaded && hasWebinars;
}
